if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('quick-buy-dialog-content') || item.target.id === "dialogBodyQuickView") {
                    setTimeout(()=>{
                        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
                    }, 2000)
                   
                }
                
                let brandNewCardsAdded = false;
                if (item.addedNodes && item.addedNodes.length > 0) {
                    for (let node of item.addedNodes) {
                        if (node.nodeType === 1 && (
                            node.classList.contains('grid__item') || 
                            node.classList.contains('js-product-card-block') ||
                            node.querySelector('.js-product-card-block')
                        )) {
                            brandNewCardsAdded = true;
                            break;
                        }
                    }
                }

                if (
                   brandNewCardsAdded || 
                   (item.target.classList && (
                       item.target.classList.contains('predictive-search-results-panel') || 
                       item.target.classList.contains('search-main')
                   ))
                ) {
                   handleCartDrawerFooterMutation();
                }           
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    async function handleCartDrawerFooterMutation() {
        if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                    BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                        ...res
                    });
                }
            }
        }
    }
}
